import React from "react";
import AdminShell from "@/pages/admin/AdminShell";
import { VillasAdmin } from "@/pages/admin/AdminDashboard";

export default function VillasPage() {
  return <AdminShell><VillasAdmin /></AdminShell>;
}
